function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f2f2f2;}.b{fill:#3f3d56;}.c{fill:#247dbd;}.d{fill:#2f2e41;}.e{fill:#ffb8b8;}.f{fill:#ccc;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(111.903 120.389)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M658.481,650.924a9.446,9.446,0,0,1-1-3.732c-.228-2.28-.081-6.124,1.912-11.486a23.162,23.162,0,0,0-.918-18.434l.229-.133a20.366,20.366,0,0,1,1.919,5.438,23.72,23.72,0,0,1-.982,13.222c-3.77,10.14-.967,14.94-.938,14.987Z",
  transform: "translate(-650.553 -613.23)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 1.722,
  cy: 1.722,
  r: 1.722,
  transform: "translate(4.729)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 1.722,
  cy: 1.722,
  r: 1.722,
  transform: "translate(10.16 6.359)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 1.722,
  cy: 1.722,
  r: 1.722,
  transform: "translate(6.451 10.598)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 1.722,
  cy: 1.722,
  r: 1.722,
  transform: "translate(10.955 14.175)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 1.722,
  cy: 1.722,
  r: 1.722,
  transform: "translate(5.126 19.74)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M664.515,722.664s-1.722-4.239,3.444-7.419Z",
  transform: "translate(-655.547 -684.908)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M638.823,730.38s-.784-4.508-6.85-4.47Z",
  transform: "translate(-631.972 -692.7)"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M307.189,239.69a6.963,6.963,0,1,1,6.963-6.963A6.963,6.963,0,0,1,307.189,239.69Zm0-13.685a6.723,6.723,0,1,0,6.723,6.723A6.723,6.723,0,0,0,307.189,226.005Z",
  transform: "translate(-277.692 -206.9)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M569.189,239.69a6.963,6.963,0,1,1,6.963-6.963A6.963,6.963,0,0,1,569.189,239.69Zm0-13.685a6.723,6.723,0,1,0,6.723,6.723A6.723,6.723,0,0,0,569.189,226.005Z",
  transform: "translate(-469.112 -206.9)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M342.146,217.469H220.855c-2.361,0-4.275,2.368-4.278,5.285v57.826c0,2.917,1.917,5.28,4.278,5.285H342.146c2.361,0,4.275-2.368,4.278-5.285V222.754c0-2.917-1.917-5.28-4.278-5.285Zm3.775,63.112c0,2.574-1.691,4.66-3.775,4.663H220.855c-2.084,0-3.771-2.089-3.775-4.663V222.754c0-2.574,1.691-4.66,3.775-4.663H342.146c2.084,0,3.771,2.089,3.775,4.663Z",
  transform: "translate(-216.577 -200.839)"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 21.551,
  height: 15.086,
  transform: "translate(8.89 39.888)"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 21.551,
  height: 15.086,
  transform: "translate(39.061 39.888)"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 21.551,
  height: 15.086,
  transform: "translate(69.233 39.888)"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 21.551,
  height: 15.086,
  transform: "translate(99.405 39.888)"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 21.551,
  height: 15.086,
  transform: "translate(8.89 61.978)"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 21.551,
  height: 15.086,
  transform: "translate(39.061 61.978)"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 21.551,
  height: 15.086,
  transform: "translate(69.233 61.978)"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 21.551,
  height: 15.086,
  transform: "translate(99.405 61.978)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M374.428,392.767l-5.087-7.026,1.386-1,3.894,5.378,14.9-15.31L390.749,376Z",
  transform: "translate(-328.188 -315.791)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M487.428,310.767l-5.087-7.026,1.386-1,3.894,5.378,14.9-15.31L503.749,294Z",
  transform: "translate(-410.747 -255.881)"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  className: "d",
  width: 0.368,
  height: 25.859,
  transform: "translate(29.22)"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  className: "d",
  width: 0.368,
  height: 25.859,
  transform: "translate(100.07)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M703.8,742.252H601.636a.37.37,0,1,1,0-.739H703.8a.37.37,0,1,1,0,.739Z",
  transform: "translate(-497.617 -583.71)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M263.428,310.767l-5.087-7.026,1.386-1,3.894,5.378,14.9-15.31L279.748,294Z",
  transform: "translate(-247.09 -255.881)"
});

var _ref21 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(158.417 58.092)"
}, /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M867.394,479.619a2.83,2.83,0,0,1,.437-.094l5.9-11.988-1.8-2.7,3.719-3.251,4.676,5.722-9.523,13.86a2.828,2.828,0,1,1-3.407-1.549Z",
  transform: "translate(-849.024 -437.286)"
}), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M880.192,447.961a1.217,1.217,0,0,1-.274.215l-6.036,3.5a1.212,1.212,0,0,1-1.657-.441c-.017-.029-.033-.059-.047-.089l-2.936-6.2a1.205,1.205,0,0,1,.414-1.521l3.741-2.545a1.212,1.212,0,0,1,1.541.147l5.229,5.248a1.212,1.212,0,0,1,.023,1.689Z",
  transform: "translate(-851.751 -422.003)"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M919.842,689.374l-3.187.867-4.861-11.88,4.7-1.28Z",
  transform: "translate(-882.926 -594.729)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M912.448,720.31l6.146-1.672,1.053,3.869-10.015,2.725a4.01,4.01,0,0,1,2.817-4.922h0Z",
  transform: "translate(-881.242 -625.09)"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M827.318,697.191h-3.3l-1.571-12.739h4.874Z",
  transform: "translate(-817.646 -600.114)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M808.644,728.236h6.369v4.011h-10.38a4.011,4.011,0,0,1,4.01-4.011Z",
  transform: "translate(-804.634 -632.103)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "e",
  cx: 6.616,
  cy: 6.616,
  r: 6.616,
  transform: "translate(6.535 1.413)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M822.543,559.939H818.03a1.216,1.216,0,0,1-1.212-1.138c-1.345-21.379-.558-36.715,2.476-48.262a1.248,1.248,0,0,1,.049-.149l.243-.6a1.207,1.207,0,0,1,1.126-.762h9.281a1.21,1.21,0,0,1,.921.423l1.261,1.471c.024.028.048.058.07.089,5.684,7.927,10.778,23.425,16.678,44.255a1.208,1.208,0,0,1-.8,1.486l-4.849,1.552a1.219,1.219,0,0,1-1.462-.628l-12.587-26.106a.943.943,0,0,0-1.783.282l-3.7,27.043a1.217,1.217,0,0,1-1.2,1.048Z",
  transform: "translate(-813.073 -471.944)"
}), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M838.97,450h-.038l-11.274-.357a1.208,1.208,0,0,1-1.166-1.065c-1.428-11.568,2.49-14.667,4.242-15.463a.931.931,0,0,0,.542-.739l.152-1.212a1.207,1.207,0,0,1,.24-.589,13.853,13.853,0,0,1,8.486-5.059,1.21,1.21,0,0,1,1.405.977c0,.02.007.04.009.06l.227,1.741a.959.959,0,0,0,.192.455c5.727,7.487-.653,18.541-1.99,20.681h0A1.214,1.214,0,0,1,838.97,450Z",
  transform: "translate(-820.379 -410.92)"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M833.628,510.793l-8.518,1.641-.324-1.68,6.52-1.257-7.578-19.976,1.6-.607Z",
  transform: "translate(-818.585 -457.253)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M846.5,380.156a26.337,26.337,0,0,0-5.254-5.5,15.616,15.616,0,0,0-5.579-2.951,8.653,8.653,0,0,0-6.186.552c-1.87.994-3.805,2.97-3.817,5.089,0,.681.169,1.6.84,1.484l.194.027,4.851-.98,2.066,7.17a1.385,1.385,0,0,0,2.246,1.1c.075-.031.719-1.477.719-1.477a.269.269,0,0,1,.464-.078l.383.478a.539.539,0,0,0,.628.162l7.911-3.3c.365-.152.772-.35.877-.731A1.314,1.314,0,0,0,846.5,380.156Z",
  transform: "translate(-819.997 -371.381)"
}), /*#__PURE__*/React.createElement("path", {
  className: "e",
  d: "M857.272,496.916a2.894,2.894,0,0,0,.379-4.421l2.094-25.288-6.235.858-.119,24.568a2.909,2.909,0,0,0,3.879,4.283Z",
  transform: "translate(-839.732 -441.392)"
}), /*#__PURE__*/React.createElement("path", {
  className: "f",
  d: "M858.985,451.45a1.208,1.208,0,0,1-.345-.05l-6.693-1.969a1.212,1.212,0,0,1-.821-1.505c.01-.032.02-.064.032-.1l2.477-6.4a1.206,1.206,0,0,1,1.388-.747l4.422.961a1.212,1.212,0,0,1,.954,1.218l-.206,7.406a1.212,1.212,0,0,1-1.209,1.179Z",
  transform: "translate(-838.565 -421.995)"
}));

const SvgDashboardAddAppointment = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206.581,
    height: 158.542,
    viewBox: "0 0 206.581 158.542",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashboardAddAppointment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Dashboard_AddAppointment.d685965f.svg";
export { ForwardRef as ReactComponent };